<template>
  <div>
    <div class='topBar'>
      <span class='left'>
        <span id='logo' @click='jumpToIndex'> TTFL </span>
      </span>
      <span class='right'>
        <el-dropdown @command='setLanguage'>
          <span id='lang' class='el-dropdown-link'>
            {{lang}}
            <i class='el-icon-arrow-down el-icon--right'></i>
          </span>
          <el-dropdown-menu slot='dropdown'>
            <el-dropdown-item command='lang_cn'>简体中文 (Simplified Chinese)</el-dropdown-item>
            <el-dropdown-item command='lang_en'>English (英文)</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>

        <el-dropdown @command='moreContent'>
          <span id='more' @click='jumpToMini'>
            {{more}}
            <i class='el-icon-arrow-down el-icon--right'></i>
          </span>
          <el-dropdown-menu slot='dropdown'>
            <el-dropdown-item command='liferemaker'>人生重开模拟器 - LifeRemaker</el-dropdown-item>
            <el-dropdown-item command='cybermerit'>赛博木鱼 - CyberMerit</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>

      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'component-header',
  data () {
    return {
      langData_lang: ['中文 (Chinese)', 'English (英文)'],
      langData_more: ['更多内容', 'More Content'],
      lang: '中文 (Chinese)',
      more: '更多内容'
    }
  },
  methods: {
    setLanguage (lang) {
      this.$bus.$emit('setLang', lang);
      if (lang == 'lang_cn') {
        this.lang = this.langData_lang[0];
        this.more = this.langData_more[0];
      }
      else if (lang == 'lang_en') {
        this.lang = this.langData_lang[1];
        this.more = this.langData_more[1];
      }
    },
    moreContent (content) {
      this.$bus.$emit('playContent', content);
    },
    jumpToIndex () {
      location.href = 'http://ttfl.net'
    },
    jumpToMini () {
      this.$bus.$emit('showMiniList');
    }
  },
}
</script>

<style scoped>
.topBar {
  width: 100%;
  height: 40px;
  background-color: rgb(78, 205, 255);
  text-align: center;
  line-height: 40px;
}
.topBar #logo {
  float: left;
  margin: 0 0 0 15px;
  font-size: 30px;
  font-weight: bolder;
  cursor: pointer;
}
.topBar .right {
  float: right;
  margin: 0 15px 0 0;
  font-size: 15px;
  font-weight: bolder;
  cursor: pointer;
}
.topBar .right #lang {
  margin: 0 15px 0 0;
}
</style>